import React from 'react';
import { TwoColumnFactbox } from '../../../../ui-components/data-viz-ui/factboxes/two-column-factbox copy/TwoColumnFactbox';
import { ComponentWithMeta } from '../../../common/component-utils';
import { KpiTwoColumnUiComponentProps } from './types';

export const KpiTwoColumnUiComponent = (
  props: KpiTwoColumnUiComponentProps
) => {
  const { meta, componentProps } = props;
  return (
    <ComponentWithMeta
      meta={meta}
      componentProps={componentProps}
      children={(props) => <TwoColumnFactbox {...props} />}
    />
  );
};
